import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add_no_color",
  "use": "icon-add_no_color-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add_no_color\">\n    <path d=\"M13 5.94506H7.05503V0H5.94506V5.94506H0V7.05503H5.94506V13.0003H7.05503V7.05503H13V5.94506Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol